// extracted by mini-css-extract-plugin
module.exports = {"item":"item","item__tag":"item__tag"};